<template>
    <div class="dataEffect">
        <div class="dataEffect-menu">
            <MyMenu :menuList="menuList" v-model="menuIndexComponent" @select="handleSelectMenu"></MyMenu>
        </div>
        <div class="dataEffect-content">
            <div class="dataEffect-content-breadcrumb">
				<Breadcrumb :list="breadcrumbList"></Breadcrumb>
			</div>
            <div class="layout-content">
				<slot>
					
				</slot>
			</div>
        </div>

        <input style="position: fixed; bottom: -99999px" type="text" id="copyInput">
    </div>
</template>

<script>
import Menu from 'iview/src/components/menu';
import SubMenu from 'iview/src/components/submenu';
import MenuItem from 'iview/src/components/menu-item';
import MyMenu from '@/components/menu/menu.vue'
import Breadcrumb from '@/components/breadcrumb/breadcrumb.vue'

export default {
    components: {
        Menu,
        SubMenu,
        MenuItem,
		MyMenu,
		Breadcrumb
    },
    data() {
        return {
            menuIndexComponent: 0
        }
    },
    props: {
        breadcrumbList: {
            type: Array,
            default: () => {
                return []
            }
        },
        menuList: {
            type: Array,
            default: () => {
                return []
            }
        },
        menuIndex: {
            type: Number,
            default: 0
        }
    },
    mounted() {
		this.menuIndexComponent = this.menuIndex
    },
    methods: {

        // 处理选择菜单项时触发
        handleSelectMenu(event) {
            const { menuItem, menuKey } = event
            if (this.$route.path !== menuItem.router) {
                this.$router.push(menuItem.router)
            }
            this.$emit('select', menuKey)
        }
    },
    watch: {
        menuIndex(index) {
            this.menuIndexComponent = index
        }
    }
}
</script>

<style lang="scss" scoped>
.dataEffect {
    height: 100%;
    display: flex;
    flex-direction: row;
}

.dataEffect-menu {
    min-width: 200px;
    height: 100%;
    padding-top: 32px;
    background-color: #fff;
}



.dataEffect-content {
	position: relative;
	display: flex;
	flex-direction: column;
    width: calc(100% - 200px);
    height: 100%;
	background-color: #f7f7f7;
    
	.dataEffect-content-breadcrumb {
		z-index: 2;
		position: absolute;
		left: 20px;
		right: 20px;
		top: 0;
		background-color: #f7f7f7;
	}
	.layout-content {
		overflow-y: auto;
		position: absolute;
		left: 0;
		right: 0;
		top: 0px;
		bottom: 0;
		padding: 52px 40px 30px 20px;
		background-color: #f7f7f7;
	}
}

@media screen and (max-width: 768px) {
    .dataEffect  {
        flex-direction: column;
    }
    .dataEffect-menu {
        display: none;
    }
    .dataEffect-content {
        width: 100%;
        .dataEffect-content-breadcrumb {
            display: none;
        }
        .layout-content {
            height: 100%;
            position: relative;
            padding: 0;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/home/layout.vue